"use client";

import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	type AnchorHTMLAttributes,
	type ButtonHTMLAttributes,
	createElement,
	forwardRef,
} from "react";
import { useIntl } from "react-intl";
import { cn } from "../../../..";

type ComponentTypes = "a" | "button";

type ComponentVariant = AnchorHTMLAttributes<HTMLAnchorElement> &
	ButtonHTMLAttributes<HTMLButtonElement>;

export interface CircleButtonProps {
	component: ComponentTypes;
	color?: "primary-medium" | "shades-medium";
	icon?:
		| "circle"
		| "circle-check"
		| "circle-exclamation"
		| "circle-info"
		| "circle-minus"
		| "circle-plus"
		| "circle-xmark"
		| "circle-arrow-left"
		| "circle-arrow-right";
}

export const CircleButton = forwardRef<ComponentVariant, CircleButtonProps & ComponentVariant>(
	function Ref(props, ref) {
		const {
			component,
			color = "primary-medium",
			icon = faCircleInfo,
			title,
			className,
			...remainingProps
		} = props;

		const intl = useIntl();

		return createElement(
			component,
			{
				...remainingProps,
				type: component === "button" ? (remainingProps.type ?? "button") : undefined,
				"aria-label":
					title ?? intl.formatMessage({ defaultMessage: "Meer informatie", id: "Mv6ZTa" }),
				className: cn(
					"inline-flex appearance-none items-center justify-center rounded-full hover:ring-1 hover:ring-offset-1 focus:outline-none focus-visible:ring-1 focus-visible:ring-offset-1 motion-safe:transition",
					{
						"text-primary-medium hover:ring-primary-medium focus-visible:ring-primary-medium":
							color === "primary-medium",
						"text-shades-medium hover:ring-shades-medium focus-visible:ring-shades-medium":
							color === "shades-medium",
					},
					className,
				),
				ref,
			},
			<FontAwesomeIcon icon={icon} />,
		);
	},
);
